import {
  useSearch,
  useProduct,
  useReviews,
  useReviewSentiments,
  useReviewPhotos,
  useQuestionsAnswers,
  useShipping,
  useDynamicRecs,
  useAisleBay,
  useAisleBayTextMe,
  useFBR,
  useFBT,
  useIRG,
  useMediaPriceInventory,
  useMetadata,
  useProtectionPlan,
  useServiceAddOns,
  useCollectionDetail,
  useSEOLinks,
  useSEOGeneratedContent,
  useStoreSearch,
  useRelatedSearchNav,
  useMylist,
  useDataModel,
  useEventsMetadata,
  useEndCap,
  useStoreDetails,
  useLoyaltyMembership,
  usePackage
} from '../../index';

// export const useProductDeprecated = ({ itemId }) => {
export const useProductDeprecated = (...args) => {
  // const opts = {
  //   variables: {
  //     itemId
  //   }
  // };
  // return useDataModel('product', opts);
  return useProduct(...args);
};

export const useProductDeprecatedClient = (...args) => {
  return useProduct(...args);
};

export const _useProductDeprecated = ({ itemId, storeId, skip, ssr }) => {

  const opts = {
    variables: {
      itemId,
      storeId,
    },
    skip,
    ssr
  };
  return useDataModel('product', opts);
};

export const useSearchDeprecated = (...args) => {
  return useSearch(...args);
};

export const useReviewsDeprecated = (...args) => {
  return useReviews(...args);
};

export const useReviewSentimentsDeprecated = (...args) => {
  return useReviewSentiments(...args);
};

export const useReviewPhotosDeprecated = (...args) => {
  return useReviewPhotos(...args);
};

export const useQuestionsAnswersDeprecated = (...args) => {
  return useQuestionsAnswers(...args);
};

export const useShippingDeprecated = (...args) => {
  return useShipping(...args);
};

export const useDynamicRecsDeprecated = (...args) => {
  return useDynamicRecs(...args);
};

export const useAisleBayDeprecated = (...args) => {
  return useAisleBay(...args);
};

export const useAisleBayTextMeDeprecated = (...args) => {
  return useAisleBayTextMe(...args);
};

export const useProtectionPlanDeprecated = (...args) => {
  return useProtectionPlan(...args);
};

export const useFBTDeprecated = (...args) => {
  return useFBT(...args);
};

export const useIRGDeprecated = (...args) => {
  return useIRG(...args);
};

export const useMediaPriceInventoryDeprecated = (...args) => {
  return useMediaPriceInventory(...args);
};

// export const useMetadataDeprecated = ({ skip, parentId, ssr }) => {
export const useMetadataDeprecated = (...args) => {
  // const opts = {
  //   ssr,
  //   skip,
  //   variables: {
  //     parentId
  //   }
  // };
  // return useDataModel('metadata', opts);
  return useMetadata(...args);
};

export const useServiceAddOnsDeprecated = (...args) => {
  return useServiceAddOns(...args);
};

export const useCollectionDetailDeprecated = (...args) => {
  return useCollectionDetail(...args);
};

export const useSEOLinksDeprecated = (...args) => {
  return useSEOLinks(...args);
};

export const useSEOGeneratedContentDeprecated = (...args) => {
  return useSEOGeneratedContent(...args);
};

export const useStoreSearchDeprecated = (...args) => {
  return useStoreSearch(...args);
};

export const useRelatedSearchNavDeprecated = (...args) => {
  return useRelatedSearchNav(...args);
};

export const useMylistDeprecated = (...args) => {
  return useMylist(...args);
};

export const useEventsMetadataDeprecated = (...args) => {
  return useEventsMetadata(...args);
};

export const useEndCapDeprecated = (...args) => {
  return useEndCap(...args);
};

export const useStoreDetailsDeprecated = (...args) => {
  return useStoreDetails(...args);
};

export const useLoyaltyMembershipDeprecated = (...args) => {
  return useLoyaltyMembership(...args);
};

export const useFBRDeprecated = (...args) => {
  return useFBR(...args);
};

export const usePackageDeprecated = (...args) => {
  return usePackage(...args);
};
